import service from '../services/shopify.service';

export const shopify = {
    namespaced: true,
    state: {},
    getters: {},
    actions: {
        async syncMarked() {
            try {
                const response = await service.syncMarked();
                return response;
            } catch (error) {
                console.error('Error syncing marked products to Shopify:', error);
                throw error.response;
            }
        },
        async syncInventory() {
            try {
                const response = await service.syncInventory();
                return response;
            } catch (error) {
                console.error('Error syncing Shopify inventory:', error);
                throw error.response;
            }
        },
    },
    mutations: {},
};
